export default {
    topics: [
        {
            title: ' abstractForm ',
            href: 's-xtk-abstractForm.html',
            attributes: { 'data-id': 's-xtk-abstractForm' },
            menu: { hasChildren: false },
            tocID: 's-xtk-abstractForm-d66e79',
            next: 's-xtk-abstractForm-d66e79',
        },
        {
            title: ' builder ',
            href: 's-xtk-builder.html',
            attributes: { 'data-id': 's-xtk-builder' },
            menu: { hasChildren: false },
            tocID: 's-xtk-builder-d66e135',
            next: 's-xtk-builder-d66e135',
        },
        {
            title: ' conflict ',
            href: 's-xtk-conflict.html',
            attributes: { 'data-id': 's-xtk-conflict' },
            menu: { hasChildren: false },
            tocID: 's-xtk-conflict-d66e361',
            next: 's-xtk-conflict-d66e361',
        },
        {
            title: ' counter ',
            href: 's-xtk-counter.html',
            attributes: { 'data-id': 's-xtk-counter' },
            menu: { hasChildren: false },
            tocID: 's-xtk-counter-d66e393',
            next: 's-xtk-counter-d66e393',
        },
        {
            title: ' dataTransfer ',
            href: 's-xtk-dataTransfer.html',
            attributes: { 'data-id': 's-xtk-dataTransfer' },
            menu: { hasChildren: false },
            tocID: 's-xtk-dataTransfer-d66e409',
            next: 's-xtk-dataTransfer-d66e409',
        },
        {
            title: ' dictionaryString ',
            href: 's-xtk-dictionaryString.html',
            attributes: { 'data-id': 's-xtk-dictionaryString' },
            menu: { hasChildren: false },
            tocID: 's-xtk-dictionaryString-d66e473',
            topics: [],
        },
        {
            title: ' enum ',
            href: 's-xtk-enum.html',
            attributes: { 'data-id': 's-xtk-enum' },
            menu: { hasChildren: false },
            tocID: 's-xtk-enum-d66e481',
            next: 's-xtk-enum-d66e481',
        },
        {
            title: ' fileRes ',
            href: 's-xtk-fileRes.html',
            attributes: { 'data-id': 's-xtk-fileRes' },
            menu: { hasChildren: false },
            tocID: 's-xtk-fileRes-d66e513',
            next: 's-xtk-fileRes-d66e513',
        },
        {
            title: ' folder ',
            href: 's-xtk-folder.html',
            attributes: { 'data-id': 's-xtk-folder' },
            menu: { hasChildren: false },
            tocID: 's-xtk-folder-d66e593',
            next: 's-xtk-folder-d66e593',
        },
        {
            title: ' fusion ',
            href: 's-xtk-fusion.html',
            attributes: { 'data-id': 's-xtk-fusion' },
            menu: { hasChildren: false },
            tocID: 's-xtk-fusion-d66e681',
            next: 's-xtk-fusion-d66e681',
        },
        {
            title: ' job ',
            href: 's-xtk-job.html',
            attributes: { 'data-id': 's-xtk-job' },
            menu: { hasChildren: false },
            tocID: 's-xtk-job-d66e705',
            next: 's-xtk-job-d66e705',
        },
        {
            title: ' olapAggregate ',
            href: 's-xtk-olapAggregate.html',
            attributes: { 'data-id': 's-xtk-olapAggregate' },
            menu: { hasChildren: false },
            tocID: 's-xtk-olapAggregate-d66e811',
            next: 's-xtk-olapAggregate-d66e811',
        },
        {
            title: ' olapCube ',
            href: 's-xtk-olapCube.html',
            attributes: { 'data-id': 's-xtk-olapCube' },
            menu: { hasChildren: false },
            tocID: 's-xtk-olapCube-d66e835',
            next: 's-xtk-olapCube-d66e835',
        },
        {
            title: ' olapDimension ',
            href: 's-xtk-olapDimension.html',
            attributes: { 'data-id': 's-xtk-olapDimension' },
            menu: { hasChildren: false },
            tocID: 's-xtk-olapDimension-d66e964',
            next: 's-xtk-olapDimension-d66e964',
        },
        {
            title: ' olapMeasure ',
            href: 's-xtk-olapMeasure.html',
            attributes: { 'data-id': 's-xtk-olapMeasure' },
            menu: { hasChildren: false },
            tocID: 's-xtk-olapMeasure-d66e1012',
            next: 's-xtk-olapMeasure-d66e1012',
        },
        {
            title: ' operator ',
            href: 's-xtk-operator.html',
            attributes: { 'data-id': 's-xtk-operator' },
            menu: { hasChildren: false },
            tocID: 's-xtk-operator-d66e1028',
            next: 's-xtk-operator-d66e1028',
        },
        {
            title: ' queryDef ',
            href: 's-xtk-queryDef.html',
            attributes: { 'data-id': 's-xtk-queryDef' },
            menu: { hasChildren: false },
            tocID: 's-xtk-queryDef-d66e1052',
            next: 's-xtk-queryDef-d66e1052',
        },
        {
            title: ' report ',
            href: 's-xtk-report.html',
            attributes: { 'data-id': 's-xtk-report' },
            menu: { hasChildren: false },
            tocID: 's-xtk-report-d66e1132',
            next: 's-xtk-report-d66e1132',
        },
        {
            title: ' serverOptions ',
            href: 's-xtk-serverOptions.html',
            attributes: { 'data-id': 's-xtk-serverOptions' },
            menu: { hasChildren: false },
            tocID: 's-xtk-serverOptions-d66e1285',
            next: 's-xtk-serverOptions-d66e1285',
        },
        {
            title: ' session ',
            href: 's-xtk-session.html',
            attributes: { 'data-id': 's-xtk-session' },
            menu: { hasChildren: false },
            tocID: 's-xtk-session-d66e1317',
            next: 's-xtk-session-d66e1317',
        },
        {
            title: ' specFile ',
            href: 's-xtk-specFile.html',
            attributes: { 'data-id': 's-xtk-specFile' },
            menu: { hasChildren: false },
            tocID: 's-xtk-specFile-d66e1640',
            next: 's-xtk-specFile-d66e1640',
        },
        {
            title: ' sql ',
            href: 's-xtk-sql.html',
            attributes: { 'data-id': 's-xtk-sql' },
            menu: { hasChildren: false },
            tocID: 's-xtk-sql-d66e1664',
            next: 's-xtk-sql-d66e1664',
        },
        {
            title: ' sqlSchema ',
            href: 's-xtk-sqlSchema.html',
            attributes: { 'data-id': 's-xtk-sqlSchema' },
            menu: { hasChildren: false },
            tocID: 's-xtk-sqlSchema-d66e1681',
            next: 's-xtk-sqlSchema-d66e1681',
        },
        {
            title: ' workflow ',
            href: 's-xtk-workflow.html',
            attributes: { 'data-id': 's-xtk-workflow' },
            menu: { hasChildren: false },
            tocID: 's-xtk-workflow-d66e1745',
            next: 's-xtk-workflow-d66e1745',
        },
    ],
};

